<div class="legal-container">
    <div class="legal-content">
        <h1 class="title">Política de Cookies</h1>
        <hr class="separator-line">
        <p class="subtitle">Última actualización: febrero 2025</p>

        <h2>1. ¿Qué son las cookies?</h2>
        <p>
            Las cookies son pequeños archivos de texto que los sitios web almacenan en el dispositivo del usuario
            (ordenador, tablet o móvil) cuando los visita. Se utilizan para recordar preferencias, mejorar la
            experiencia de navegación y recopilar información analítica sobre el uso del sitio.
        </p>

        <h2>2. Tipos de cookies que utilizamos</h2>

        <p><strong>Cookies técnicas (necesarias):</strong></p>
        <ul>
            <li>Cookies de sesión de autenticación para el acceso al área privada.</li>
            <li>Cookies de seguridad para proteger las comunicaciones con el servidor.</li>
        </ul>

        <p><strong>Cookies analíticas:</strong></p>
        <ul>
            <li>Cookies de Firebase Analytics para conocer el número de visitantes y las páginas más consultadas.</li>
            <li>Estas cookies recopilan información de forma anónima y agregada.</li>
        </ul>

        <p><strong>Cookies funcionales:</strong></p>
        <ul>
            <li>Cookies para recordar preferencias de navegación del usuario.</li>
            <li>Cookies para el correcto funcionamiento del mapa interactivo (Leaflet).</li>
        </ul>

        <h2>3. Duración de las cookies</h2>
        <ul>
            <li><strong>Cookies de sesión:</strong> se eliminan al cerrar el navegador.</li>
            <li><strong>Cookies persistentes:</strong> permanecen en el dispositivo durante un periodo determinado
                o hasta que el usuario las elimine manualmente.</li>
        </ul>

        <h2>4. Cookies de terceros</h2>
        <p>Este sitio web puede utilizar servicios de terceros que instalan cookies propias:</p>
        <ul>
            <li><strong>Google Firebase:</strong> autenticación, almacenamiento de datos y analítica.</li>
            <li><strong>Leaflet / OpenStreetMap:</strong> carga de tiles del mapa interactivo.</li>
        </ul>
        <p>
            El titular no tiene control sobre las cookies de terceros. Le recomendamos consultar las políticas
            de privacidad de dichos servicios para obtener más información.
        </p>

        <h2>5. ¿Cómo gestionar las cookies?</h2>
        <p>
            El usuario puede configurar su navegador para aceptar o rechazar todas las cookies, o para recibir
            un aviso cuando se envía una cookie. Los procedimientos para bloquear y eliminar cookies pueden diferir
            de un navegador a otro. A continuación se indican los enlaces a la ayuda de los navegadores más comunes:
        </p>
        <ul>
            <li><a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noopener">Google
                    Chrome</a></li>
            <li><a href="https://support.mozilla.org/es/kb/cookies-informacion-que-los-sitios-web-guardan-en-"
                    target="_blank" rel="noopener">Mozilla Firefox</a></li>
            <li><a href="https://support.apple.com/es-es/guide/safari/sfri11471" target="_blank"
                    rel="noopener">Safari</a></li>
            <li><a href="https://support.microsoft.com/es-es/microsoft-edge/eliminar-cookies-en-microsoft-edge-63947406-40ac-c3b8-57b9-2a946a29ae09"
                    target="_blank" rel="noopener">Microsoft Edge</a></li>
        </ul>
        <p>
            Tenga en cuenta que la desactivación de cookies puede afectar al correcto funcionamiento de algunas
            secciones del sitio web, como el acceso al área privada o el mapa interactivo.
        </p>

        <h2>6. Actualizaciones de esta política</h2>
        <p>
            Esta Política de Cookies puede ser actualizada periódicamente para reflejar cambios en las cookies
            utilizadas o por motivos legales. Se recomienda al usuario revisarla regularmente.
        </p>
    </div>
</div>